if (window.location.href.indexOf("prospect%2Cnewsletter&form_type=customer") > -1 && document.querySelector('.email-exist-message')) {
  document.querySelector('.email-exist-message').classList.remove('hidden');
}
/*-- For Cookie Consent Pop Up Glitch --*/
setInterval(function () {
  $(document).find(".cc-window.cc-floating:not(.cc-invisible)").length
    ? $("body").addClass("cookie-consent")
    : $("body").removeClass("cookie-consent");
}, 500);


function swatchSelector(event) {
  //   console.log(event.target);
  let BtnElement = event.target;
  $(event.target).parents(".swatches-wrapper").find(".swatch-active").removeClass("swatch-active");
  $(event.target).addClass("swatch-active");
  let swatchColorName = $(event.target).attr("data-swatch-name");
  $(event.target).parents(".collection-page-swatch").find(".color-name").text(swatchColorName);
  let gridItem = BtnElement.closest(".collection-product-block");
  let ProductJson = JSON.parse(BtnElement.querySelector(".product-json").innerHTML);
  const getPadding = (aspectRatio) => {
    let padding = 1;
    return ((padding / aspectRatio) * 100);
  };
  console.log(ProductJson);
  let priceElement = ""
  if (window.theme.custom && window.theme.custom.discountCollectionPercentage && ProductJson.tags.includes(`discount_${window.theme.custom.discountCollectionPercentage}`)) {
    if (window.theme.custom.discountCollectionPrice == ProductJson.compare_at_price) {
      priceElement = `<span class="theme-money">${window.theme.custom.discountCollectionPrice}</span>`
    } else {
      if (ProductJson.compare_at_price != null) {
        priceElement = `
              <span class="theme-money">${window.theme.custom.discountCollectionPrice}</span>
              <span class="was-price theme-money">${theme.Shopify.formatMoney(ProductJson.price, window.theme.money_format).replaceAll(".00", "")}</span>
              `;
      } else {
        priceElement = `<span class="theme-money">${window.theme.custom.discountCollectionPrice}</span>`
      }
    }
  }
  else {
    if (ProductJson.price == ProductJson.compare_at_price) {
      if (BtnElement.getAttribute('data-tagexist') == 'true') {
        priceElement = `<span class="theme-money">${BtnElement.closest('.product_grid_content_wrap').querySelector('.js-swatch-price').value}</span>
                             <span class="was-price theme-money">${theme.Shopify.formatMoney(ProductJson.price, window.theme.money_format).replaceAll(".00", "")}</span>`;
      } else {
        priceElement = `<span class="theme-money">${theme.Shopify.formatMoney(ProductJson.price, window.theme.money_format).replaceAll(".00", "")}</span>`;
      }
      // priceElement = `<span class="theme-money">${theme.Shopify.formatMoney(ProductJson.price, window.theme.money_format).replaceAll(".00", "")}</span>`
    } else {
      if (ProductJson.compare_at_price != null) {
        priceElement = `
    <span class="theme-money">${theme.Shopify.formatMoney(ProductJson.price, window.theme.money_format).replaceAll(".00", "")}</span>
    <span class="was-price theme-money">${theme.Shopify.formatMoney(ProductJson.compare_at_price, window.theme.money_format).replaceAll(".00", "")}</span>
    `;
      } else {
        priceElement = `<span class="theme-money">${theme.Shopify.formatMoney(ProductJson.price, window.theme.money_format).replaceAll(".00", "")}</span>`
      }



    }
  }

  $(event.target).parents(".product-block__inner").find(".price").html(priceElement);


  /*-- Load Media --*/
  if (ProductJson.media.length) {
    let firstImageHtml = `<div class="rimage-outer-wrapper" style="max-width: ${ProductJson.media[0].width} px">
<div class="rimage-wrapper " style="padding-top:${getPadding(ProductJson.media[0].aspect_ratio)}%">
<img class="rimage__image fade-in lazyload" data-widths="[720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt="" 
data-srcset="${ProductJson.media[0].src}_720x.png?v=1626405866 720w, ${ProductJson.media[0].src}_900x.png?v=1626405866 900w, ${ProductJson.media[0].src}_1080x.png?v=1626405866 1080w, ${ProductJson.media[0].src}_1296x.png?v=1626405866 1296w, ${ProductJson.media[0].src}_1512x.png?v=1626405866 1512w, ${ProductJson.media[0].src}_1728x.png?v=1626405866 1728w, ${ProductJson.media[0].src}_2048x.png?v=1626405866 2048w" sizes="445px" srcset="${ProductJson.media[0].src}_720x.png?v=1626405866 720w, ${ProductJson.media[0].src}_900x.png?v=1626405866 900w, ${ProductJson.media[0].src}_1080x.png?v=1626405866 1080w, ${ProductJson.media[0].src}_1296x.png?v=1626405866 1296w, ${ProductJson.media[0].src}_1512x.png?v=1626405866 1512w, ${ProductJson.media[0].src}_1728x.png?v=1626405866 1728w, ${ProductJson.media[0].src}_2048x.png?v=1626405866 2048w">
<noscript>
<img src="${ProductJson.media[0].src}_1024x1024.png?v=1626405866" alt="${ProductJson.title}" class="rimage__image">
</noscript>
</div>
</div>`;

    gridItem.querySelector(".image__first").innerHTML = "";
    gridItem.querySelector(".image__first").innerHTML = firstImageHtml;

    if (ProductJson.media[1]) {
      let secondImageHtml = `<div class="rimage-outer-wrapper" style="max-width: ${ProductJson.media[1].width} px">
<div class="rimage-wrapper " style="${getPadding(ProductJson.media[1].aspect_ratio)}">
<img class="rimage__image fade-in lazyload" data-widths="[720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt="" 
data-srcset="${ProductJson.media[1].src}_720x.png?v=1626405866 720w, ${ProductJson.media[1].src}_900x.png?v=1626405866 900w, ${ProductJson.media[1].src}_1080x.png?v=1626405866 1080w, ${ProductJson.media[1].src}_1296x.png?v=1626405866 1296w, ${ProductJson.media[1].src}_1512x.png?v=1626405866 1512w, ${ProductJson.media[1].src}_1728x.png?v=1626405866 1728w, ${ProductJson.media[1].src}_2048x.png?v=1626405866 2048w" sizes="445px" srcset="${ProductJson.media[1].src}_720x.png?v=1626405866 720w, ${ProductJson.media[1].src}_900x.png?v=1626405866 900w, ${ProductJson.media[1].src}_1080x.png?v=1626405866 1080w, ${ProductJson.media[1].src}_1296x.png?v=1626405866 1296w, ${ProductJson.media[1].src}_1512x.png?v=1626405866 1512w, ${ProductJson.media[1].src}_1728x.png?v=1626405866 1728w, ${ProductJson.media[1].src}_2048x.png?v=1626405866 2048w">
<noscript>
<img src="${ProductJson.media[1].src}_1024x1024.png?v=1626405866" alt="${ProductJson.title}" class="rimage__image">
</noscript>
</div>
</div>`;
      if (gridItem.querySelector(".image__second")) gridItem.querySelector(".image__second").innerHTML = "";
      if (gridItem.querySelector(".image__second")) gridItem.querySelector(".image__second").innerHTML = secondImageHtml;
    }
  }

  /*-- Load Sizes --*/
  gridItem.querySelector(".size-wrapper").innerHTML = "";
  //gridItem.querySelector(".size-wrapper").innerHTML += `<div class="quick-form__variant-message">TALLAS DISPONIBLES:</div>`;
  let sizeHTML = ""
  for (let variant of ProductJson.variants) {
    //     console.log(variant);
    let variantId = variant.id;
    let variantAvailable = variant.available;
    let variantTitle = variant.title;
    let showSoldOut = "";
    !variantAvailable ? showSoldOut = "sold-out" : false;
    let variantUrl = `${ProductJson.url}?variant=${variantId}`;

    if (variant.title.includes('/')) {
      variantTitle = variantTitle.split('/');
      variantTitle = variantTitle[0];
    }
    // console.log("variantTitle",variantTitle)

    sizeHTML += `<div class="sizes ${showSoldOut}"><button onclick='window.location.href="${variantUrl}";' class="size" data-variant-id="${variantId}" data-variant-title="${variantTitle}">${variantTitle}</button></div>`;
  }
  gridItem.querySelector(".size-wrapper").innerHTML += sizeHTML;

  $(BtnElement).parents(".product-block__inner").find("a").attr("href", ProductJson.url);
  //   console.log(ProductJson);
}

function sizeSelector(event) {
  let sizeBtn = event.target;
  //console.log(sizeBtn);
  let variantId = sizeBtn.getAttribute("data-variant-id");
  let variantQty = 1;
  //console.log(variantId, variantQty);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: variantQty
    },
    dataType: 'json',
    success: function (response) {
      var offset = 25;
      var nav = theme.Nav();
      nav.bar.getPositionSetting() !== "inline" ? offset = nav.bar.height() : false;
      console.log(offset);

      var product = response;
      var noCheckoutButton = true; //Preload the thumbnail image
      var thumbUrl = theme.Shopify.formatImage(response.image, '300x');
      var img = new Image();
      img.src = thumbUrl;
      var variantHtml;
      if (product.options_with_values && product.options_with_values.length) {
        variantHtml = '';
        for (var _i = 0; _i < product.options_with_values.length; _i++) {
          var option = product.options_with_values[_i];
          if (option.name !== "Title" && option.value !== "Default Title") {
            variantHtml += "<p class=\"cart-product__content__meta\">".concat(option.name, ": ").concat(option.value, "</p>");
          }
        }
      }
      showThemeModal(['<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">', "<div class=\"inner\" style=\"top:".concat(offset, "px\">"), '<a href="#" data-modal-close class="modal-close">&times;</a>', '<h4 id="added-to-cart-title">' + theme.icons.tick + theme.strings.productAddedToCart + '</h4>', '<div class="cart-product">', "<div class=\"cart-product__image\"><img src=\"".concat(thumbUrl, "\" alt=\"").concat(response.featured_image.alt, "\"/></div>"), '<div class="cart-product__content">' + '<p class="cart-product__content__title">', response.product_title, '</p>' + "".concat(variantHtml ? variantHtml : '') + '</div>', '</div>', "<p class=\"links ".concat(noCheckoutButton ? 'links--no-checkout' : '', "\">"), '<a href="' + theme.routes.cart_url + "\" class=\"button ".concat(noCheckoutButton ? '' : 'alt', "\">") + theme.strings.viewCart + '</a>', '<a href="' + theme.routes.checkout + '" class="button button--checkout" [data-cc-checkout-button]>' + theme.strings.popupCheckout + '</a> ', '</p>', '</div>', '</div>'].join(''), null, null, false, true);
    },
    error: function (error) {
      console.log(error.responseText);
    }
  });




}

document.addEventListener('click', function (e) {
  console.log(e.target.classList.contains("swatch-btn-image"))
  if (e.target && e.target.classList.contains('size-quick-add-to-cart')) {
    sizeSelector(e);
    console.log("if")
  }
  else if (e.target && e.target.classList.contains("swatch-btn-image")) {
    console.log("else if")
    swatchSelector(e);
  }
  else {
    return false;
  }
});

function sizeEventHandler(event) {


  //   $(event.currentTarget).parents(".clickyboxes.options-talla").find("li").each(function(){
  //   	$(this).find("a").removeClass("active");
  //   });

  //   $(event.currentTarget).find("a").addClass("active");

  //   if(event.currentTarget.classList.contains("unavailable") || event.currentTarget.classList.contains("variant-sold-out")){

  //     //     if(document.querySelector(".klaviyo-bis-trigger")) document.querySelector(".klaviyo-bis-trigger").style.display = "inline-block";
  //     document.querySelector(".product-detail__form__action").querySelector("button[type='submit']").innerText = window.theme.strings.buttonNoStock;
  //     document.querySelector(".product-detail__form__action").querySelector("button[type='submit']").setAttribute("disabled", "disabled");
  //     document.querySelector(".fab-add-to-cart").innerText = window.theme.strings.buttonNoStock;
  //     document.querySelector(".fab-add-to-cart").setAttribute("disabled", "disabled");
  //   }else{
  //     //     if(document.querySelector(".klaviyo-bis-trigger"))document.querySelector(".klaviyo-bis-trigger").style.display = "none";
  //     document.querySelector(".product-detail__form__action").querySelector("button[type='submit']").innerText = window.theme.strings.buttonAddToCart;
  //     document.querySelector(".product-detail__form__action").querySelector("button[type='submit']").removeAttribute("disabled");
  //     document.querySelector(".fab-add-to-cart").innerText = window.theme.strings.buttonAddToCart;
  //     document.querySelector(".fab-add-to-cart").removeAttribute("disabled");    
  //   }
}
window.onload = function () {
  // const clickboxSize = document.querySelector(".clickyboxes.options-talla")?.querySelectorAll("li:not(.cc-hover-line)");
  // clickboxSize?.forEach(function(sizeElement) {
  //   if (!(window.location.href).includes("?variant=")) {
  //     sizeElement.querySelector("a").classList.remove("active");
  //   }

  //   sizeElement.addEventListener("click", sizeEventHandler.bind(this));
  // });
  var vid = document.getElementById("player");
  var playvideo = document.getElementById("play_video");
  if (playvideo && vid) {
    vid.onclick = function () {
      vid.addEventListener('playing', function () {
        playvideo.style.display = "none";
      })
      vid.addEventListener('pause', function () {
        playvideo.style.display = "block";
      })
      vid[vid.paused ? 'play' : 'pause']();
    }
    playvideo.onclick = function () {
      vid.play();
      playvideo.style.display = "none";
    }
    vid.onended = function () {
      playvideo.style.display = "block";
    };
  }

}
// (function(){
//   document.querySelector(".plyr__controls .swiper-no-swiping").style.display = "none !important"
// })();


//Open Size Guide Drawer
window.sizeGuideDrawer = function sizeGuideDrawer() {
  document.querySelectorAll(".menu-button").forEach(function (button) {
    button.addEventListener("click", function () {
      document.body.classList.toggle('overflow-hidden');
      if (document.querySelector(".size-guide-modal")) document.querySelector(".size-guide-modal").classList.toggle('show-sizeguide');
    });
  });

  document.querySelectorAll('.modal__header__close, .size-guide-modal-overlay').forEach(function (element) {
    element.addEventListener("click", function () {
      document.querySelector('.size-guide-modal').classList.remove('show-sizeguide');
      document.body.classList.remove('overflow-hidden');
    });
  });
}
window.sizeGuideDrawer();

//Open Size Picker On mobile PDP
if (document.querySelector('.product-detail__form__action [type="button"]')) {
  document.querySelector('.product-detail__form__action [type="button"]').addEventListener('click', function () {
    document.querySelector('.option-selectors .selector-wrapper').classList.toggle('show-sizeguide-mobile');
    document.body.classList.toggle('open-size-guide-mobile');
  });
}

//Filter tags on PDP
if (document.querySelectorAll('.tags_over_image .js-product-tags').length) {
  document.querySelectorAll('.tags_over_image .js-product-tags').forEach(function (element) {
    element.addEventListener('click', function (Element) {
      let DataTag = Element.currentTarget.getAttribute('data-tag').replace(/\s+/g, '+'),
        filterUrl = `/collections/all?filter.p.m.custom.product_tags=${DataTag}`;
      window.location.href = filterUrl;
    });
  })
}

let box = document.querySelector('.inner_box_start');
window.onscroll = function (event) {
  if (box) {
    box.classList.toggle('size-guide-fixed', (window.scrollY > document.querySelector(".product-area__media.multi-column").offsetHeight))
    // console.log(document.querySelector(".product-area__media.multi-column").offsetHeight,window.scrollY)
  }
};

//Mobile Size Picker OutSide Click Event
document.addEventListener('click', function (e) {
  const isSizeOption = e.target.classList.contains('js-size-option');
  const isFormOption = e.target.closest('form');
  const mobileStickyBtn = e.target.closest('.product-area__add-to-cart-xs .button');

  if (!isSizeOption && !isFormOption && !mobileStickyBtn) {
    document.querySelectorAll('.js-size-option').forEach(function (element) {
      if (element.classList.contains('show-sizeguide-mobile')) {
        element.classList.remove('show-sizeguide-mobile');
        document.body.classList.remove('open-size-guide-mobile');

        if (document.querySelector(".product-detail__form__action").querySelector(".button").getAttribute('type') == 'submit') {
          document.querySelector(".product-detail__form__action").querySelector(".button").setAttribute('type', 'button');
          document.querySelector(".product-detail__form__action").querySelector(".button").innerHTML = window.theme.strings.buttonChooseASizeCustom;
        }
        document.querySelectorAll('.clickyboxes.cc-init li a').forEach((item) => {
          if (item.classList.contains('active')) {
            item.classList.remove('active');
          }
        });
        if (document.querySelector('.product-area__add-to-cart-xs .button')) document.querySelector('.product-area__add-to-cart-xs .button').innerHTML = window.theme.strings.buttonChooseASizeCustom;
        if (document.querySelector('.product-area__add-to-cart-xs .button')) document.querySelector('.product-area__add-to-cart-xs .button').setAttribute('type', 'button');

        document.querySelector('.product-detail__form__action button').closest('form').classList.add('klaviyo-hidden');
        document.querySelector('.product-detail__form .product-detail__form__action .button').classList.remove('hidden');
        document.querySelector(".product-detail__form__action").querySelector(".button").removeAttribute("disabled");
        document.querySelector(".product-detail__form__action").querySelector(".button").innerHTML = window.theme.strings.buttonChooseASizeCustom;
      }
    });
  }
});

// filter remove class 
const clickRemovehidden = document.querySelector('.js-remove-hidden');
const removeclass = document.querySelector('.removeClass');
if (clickRemovehidden && removeclass) {
  console.log("dadad")
  clickRemovehidden.addEventListener('click', function () {
    removeclass.classList.toggle('hidden');
  });
}


let clickFilterButton = document.querySelector('.custom_filter_btn_resultados');
if (clickFilterButton) {
  clickFilterButton.addEventListener('click', function () {
    clickFilterButton.classList.add('hidden');
    if (document.querySelector('.custom_filter_wrap').classList.contains('custom_filter_wrap_js_open')) {
      document.querySelector('.custom_filter_wrap').classList.remove('custom_filter_wrap_js_open');
    }
    window.scroll({
      top: document.querySelector('.product-list-container').offsetTop,
      behavior: "smooth",
    });
  });
}


//PASSWORD CHECK EYE
const showButtons = document.querySelectorAll(".js-hide-show");
const inputTypeChanges = document.querySelectorAll(".js-hide-show-pass");

showButtons.forEach(function (button, index) {
  button.addEventListener("click", function () {
    const inputTypeChange = inputTypeChanges[index]; // Get the corresponding input element
    if (inputTypeChange.type === "password") {
      inputTypeChange.type = "text";
      inputTypeChange.classList.add("activepass"); // Use classList.add() to add a class
    } else {
      inputTypeChange.type = "password";
      inputTypeChange.classList.remove("activepass"); // Optionally, remove the class when changing back to password type
    }
  });
});

// scrollbuttton
const scrollbuttton = document.querySelector(".js-scroll")
if (scrollbuttton) {
  scrollbuttton.addEventListener("click", function () {
    window.scroll({
      top: document.querySelector(".js-create-customer").offsetTop,
      behavior: "smooth",
    });
  });
}

//Main Account Tab
let activeButtons = document.querySelectorAll(".sidebar_link");
let activeContents = document.querySelectorAll(".account_customer_right_side_main");
let goBackBtn = document.querySelector(".go_back_btn");

activeButtons.forEach((button, index) => {
  button.addEventListener("click", () => {
    activeButtons.forEach(btn => btn.classList.remove("active"));
    activeContents.forEach(content => content.classList.remove("active"));
    button.classList.add("active");
    activeContents[index].classList.add("active");
  });
});

let activeButtonsMobile = document.querySelectorAll(".sidebar_link_mobile");
let activeContentsMobile = document.querySelectorAll(".account_customer_right_side_main");
activeButtonsMobile.forEach((button, index) => {
  button.addEventListener("click", (event) => {
    let closestMain = event.currentTarget.closest('.custom_main_account');
    activeButtonsMobile.forEach(btn => btn.classList.remove("active"));
    activeContentsMobile.forEach(content => content.classList.remove("active"));
    button.classList.add("active");
    activeContentsMobile[index].classList.add("active");

    if (event.currentTarget.getAttribute('data-tab') == 'mis compras' || event.currentTarget.getAttribute('data-tab') == 'mi WISHLIST') {
      document.querySelector('.my_shopping_header').classList.add('hidden')
    } else {
      document.querySelector('.my_shopping_header').classList.remove('hidden')
    }

    if (closestMain.querySelector('.go_back_btn')) closestMain.querySelector('.go_back_btn').classList.remove('hidden');
    if (closestMain.querySelector('#admin_header')) closestMain.querySelector('#admin_header').classList.add('hidden');
    if (closestMain.querySelector('.account_customer_sidebar.mobile')) closestMain.querySelector('.account_customer_sidebar.mobile').classList.add('hidden');
    if (closestMain.closest('.custom_main_account').querySelector('.account_customer_right_side')) closestMain.closest('.custom_main_account').querySelector('.account_customer_right_side').classList.remove('mobile-hide')
  });
});

if (goBackBtn) {
  goBackBtn.addEventListener('click', function (Ele) {
    Ele.currentTarget.classList.add('hidden');
    if (Ele.currentTarget.closest('.custom_main_account').querySelector('#admin_header')) {
      Ele.currentTarget.closest('.custom_main_account').querySelector('#admin_header').classList.remove('hidden')
    }
    if (Ele.currentTarget.closest('.custom_main_account').querySelector('.account_customer_sidebar.mobile')) {
      Ele.currentTarget.closest('.custom_main_account').querySelector('.account_customer_sidebar.mobile').classList.remove('hidden')
    }
    if (Ele.currentTarget.closest('.custom_main_account').querySelector('.account_customer_right_side')) {
      Ele.currentTarget.closest('.custom_main_account').querySelector('.account_customer_right_side').classList.add('mobile-hide')
    }
  })
}

//Order Tab
document.querySelectorAll('.account_customer_tab .tab_item').forEach(function (ele) {
  ele.addEventListener('click', function (Element) {
    document.querySelectorAll('.account_customer_tab .tab_item').forEach(function (el) {
      el.classList.remove('active');
    })
    Element.currentTarget.classList.add('active');

    if (Element.currentTarget.classList.contains('pos-order-tab')) {
      document.querySelectorAll('.account_customer_right_item').forEach(function (evt) {
        if (evt.classList.contains('pos-orders')) {
          evt.style.display = 'flex';
        } else {
          evt.style.display = 'none';
        }
      })
    }

    if (Element.currentTarget.classList.contains('online-order-tab')) {
      document.querySelectorAll('.account_customer_right_item').forEach(function (evt) {
        if (evt.classList.contains('pos-orders')) {
          evt.style.display = 'none';
        } else {
          evt.style.display = 'flex';
        }
      })
    }
  })
})

//PreSelected grid in collection
let gridItemSize = localStorage.getItem("gridItem");
if (gridItemSize != null) {
  if (document.querySelector(`.custom_filter_right .filter_btn[data-grid="${gridItemSize}"]`)) {
    document.querySelector(`.custom_filter_right .filter_btn[data-grid="${gridItemSize}"]`).click();
    document.querySelector('.product-grid-class-handler.product-list').style.visibility = 'visible';
  }
} else {
  if (document.querySelector('.product-grid-class-handler.product-list')) document.querySelector('.product-grid-class-handler.product-list').style.visibility = 'visible';
}

//my likes form select event ACCOUNT PAGE
let dropdownItems = document.querySelectorAll('.dropdown_item');
function handleDropdownChange(event) {
  dropdownItems.forEach(item => item.classList.remove('selected'));
  event.target.classList.add('selected');
  event.currentTarget.closest('details').removeAttribute('open');
  document.querySelector('.selected-value').innerHTML = event.currentTarget.innerHTML;
  document.querySelector('.selected-value-input').value = event.currentTarget.innerHTML;
}
dropdownItems.forEach(item => {
  item.addEventListener('click', handleDropdownChange);
});

function setAnnocementbarHeight() {
  let section = document.querySelector('.slidr_for_announcement');
  if (!section) {
    console.error('Section element not found. Check the class name.');
    return;
  }

  let sectionHeight = section.offsetHeight + 'px';
  document.documentElement.style.setProperty('--announcement-bar-height', sectionHeight);
}
setAnnocementbarHeight();
window.addEventListener('resize', setAnnocementbarHeight);

// Selecting elements
// let activeButton = document.querySelectorAll(".sidebar_link_mobile");
// let goBack = document.querySelector(".go_back_btn");
// let adminHeaderContent = document.querySelector(".admin_header");
// let accountContent = document.querySelectorAll(".account_customer_right_side");

// // Adding click event listener to active buttons
// activeButton.forEach(function(button) {
//   button.addEventListener("click", function() {
//     // Removing class "hidden" from goBack and accountContent
//     goBack.classList.remove("hidden");
//      activeButton.classList.add("hidden");
//     accountContent.forEach(function(content) {
//       content.classList.remove("mobile-hide");

//     });
//   });
// });

// // Adding click event listener to goBack button
// goBack.addEventListener("click", function() {
//   // Adding class "hidden" to adminHeaderContent and activeButton
//   adminHeaderContent.classList.add("hidden");
//   activeButton.forEach(function(button) {
//     button.classList.add("hidden");
//   });
// });

{
  //menu hide show
  const firstLevelItems = document.querySelectorAll(".mob_first_level_item");
  const secondaryMenus = document.querySelectorAll(".js-secondary");

  firstLevelItems.forEach(item => {
    item.addEventListener("click", function () {
      // Remove 'active' from all first-level items
      firstLevelItems.forEach(i => i.classList.remove("active"));
      // Add 'active' to clicked item
      this.classList.add("active");

      // Get clicked item's js-first-menu-label value
      const selectedLabel = this.getAttribute("js-first-menu-label");

      // Loop through secondary menus
      secondaryMenus.forEach(menu => {
        const menuLabel = menu.getAttribute("js-secondary-menu-label");

        if (selectedLabel === menuLabel) {
          menu.classList.add("active");
        } else {
          menu.classList.remove("active");
        }
      });
    });
  });
}

{
  // Adding click event Menu Desktop closs 
  // Adding click event Menu Desktop close
  const clickDesElement = document.querySelector('.js-click-des');

  if (clickDesElement) {
    clickDesElement.addEventListener('click', function () {
      document.querySelectorAll(".first_lavel_text.has-children.expanded").forEach(item => {
        if (item.classList.contains('expanded')) {
          item.classList.remove('expanded');
          item.removeAttribute('aria-expanded');
          item.removeAttribute('aria-controls');
          theme.closeOpenMenuItem();
          const tier2Element = document.querySelector(".tier-2.tier-appeared");
          if (tier2Element) {
            tier2Element.classList.add("hidden");
          }
        }
      });
    });
  }

}

// menu item click 
{

  document.addEventListener("click", (e) => {
    const link = e.target.closest("a.js-menu-nav-link");
    if (link) {
      const dataLink = link.getAttribute("data-link");
      if (dataLink) {
        console.log(dataLink, "===>")
        localStorage.setItem("navLink", dataLink);
      }
    }
  });

  //logo Url Change 
  const savedLink = localStorage.getItem("navLink");
  if (savedLink) {
    const logoLink = document.querySelector(".js-logo");
    if (logoLink) {
      let updatedLink = savedLink;
      if (savedLink.includes("/pages/mujer")) {
        updatedLink = "/";
      }
      logoLink.href = updatedLink;
    }
  }
}







function setFooterMenuHeight() {
  let section = document.querySelector('.nav-footer-links'); // Replace with your actual class name
  if (!section) {
    console.error('Section element not found. Check the class name.');
    return;
  }

  let sectionHeight = section.offsetHeight + 'px';
  document.documentElement.style.setProperty('--nav-mobile-menu-footer', sectionHeight);
}

document.querySelectorAll('.secondary-nav_ul details').forEach(detail => {
  detail.addEventListener('toggle', function () {
    setSectionHeight();
  });
});
// Call the function to set the height initially
setSectionHeight();

// Optionally, call the function again on window resize to handle dynamic content or responsive layouts
window.addEventListener('resize', setSectionHeight);

{
  document.querySelectorAll(".theme-money").forEach(el => {
    el.textContent = el.textContent.replace(/\s*€\s*/, '€');
  });
}

{
  window.addEventListener('DOMContentLoaded', function () {
    if(document.querySelector('.mobile-count'))document.querySelector('.mobile-count').classList.remove('hidden');
  });
}


function setAnnouncementBarHeight() {
  let section = document.querySelector('.custom_announcement'); // Replace with your actual class name
  if (!section) {
    console.error('Section element not found. Check the class name.');
    return;
  }

  let sectionHeight = section.offsetHeight + 'px';
  document.documentElement.style.setProperty('--announcement-bar-height', sectionHeight);
}

// Call the function to set the height initially
setAnnouncementBarHeight();

// Optionally, call the function again on window resize to handle dynamic content or responsive layouts
window.addEventListener('resize', setAnnouncementBarHeight);


function applyThemeClass() {
  const htmlElement = document.documentElement;

  // Clear any previous theme classes
  htmlElement.classList.remove('dark', 'light', 'mode-default');

  // Add default class for all cases
  htmlElement.classList.add('mode-default');

  // Detect system/browser theme
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    htmlElement.classList.add('dark');
  } else {
    htmlElement.classList.add('light');
  }
}

// Run on load
document.addEventListener('DOMContentLoaded', function () {
  applyThemeClass();

  // Watch for changes in system theme (auto update)
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', applyThemeClass);
});


function setSectionHeight() {
  let section = document.querySelector('.nav-footer-links'); // Replace with your actual class name
  if (!section) {
    console.error('Section element not found. Check the class name.');
    return;
  }

  let sectionHeight = section.offsetHeight + 'px';
  document.documentElement.style.setProperty('--nav-mobile-menu-footer', sectionHeight);
}

// Call the function to set the height initially
setSectionHeight();

// Optionally, call the function again on window resize to handle dynamic content or responsive layouts
window.addEventListener('resize', setSectionHeight);

{
  // Reload page when crossing breakpoint (e.g., 991px)
  (function () {
    var lastIsMobile = window.innerWidth <= 991;
    window.addEventListener('resize', function () {
      var isMobile = window.innerWidth <= 991;
      if (isMobile !== lastIsMobile) {
        window.location.reload();
      }
    });
  })();

  // Swiper initialization for responsive direction (vertical on desktop, horizontal on mobile)
  function getSwiperDirection() {
    return window.innerWidth <= 991 ? 'horizontal' : 'vertical';
  }

  var verticalSwiper = new Swiper('.product-layout-vertical_carousel', {
    direction: getSwiperDirection(),
    slidesPerView: 1,
    spaceBetween: 0,
    mousewheel: true,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination-bullets', 
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChange: function () {
        var current = this.realIndex + 1;
        var total = this.slides.length;
        document.querySelector('.swiper-pagination-fraction').textContent = current + '/' + total;
      },
      init: function () {
        var current = this.realIndex + 1;
        var total = this.slides.length;
        document.querySelector('.swiper-pagination-fraction').textContent = current + '/' + total;
      }
    }
  });
  // Listen for window resize and update Swiper direction
  window.addEventListener('resize', function () {
    var newDirection = getSwiperDirection();
    if (verticalSwiper.params.direction !== newDirection) {
      verticalSwiper.changeDirection(newDirection);
    }
  });

  (function () {
    var openBtn = document.getElementById('open-size-drawer');
    var drawer = document.getElementById('size-drawer');
    var closeBtn = document.getElementById('close-size-drawer');
    if (openBtn && drawer && closeBtn) {
      openBtn.addEventListener('click', function () {
        drawer.style.display = 'block';
        document.body.style.overflow = 'hidden';
      });
      closeBtn.addEventListener('click', function () {
        drawer.style.display = 'none';
        document.body.style.overflow = '';
      });
      drawer.addEventListener('click', function (e) {
        if (e.target.classList.contains('drawer-size-btn')) {
          var variantId = e.target.getAttribute('data-variant-id');
          var selector = document.querySelector('.original-selector');
          if (selector) {
            selector.value = variantId;
            var event = new Event('change', { bubbles: true });
            selector.dispatchEvent(event);
          }
          drawer.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
      // Optional: close drawer when clicking outside content
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) {
          drawer.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
    }
  })();

}

function setPdpdiscriptionHeight() {
  const pdpdiscription = document.querySelector('.product-detail__form__description');
  if (pdpdiscription) {
    const pdpdiscriptionHeight = pdpdiscription.offsetHeight + 'px';
    document.documentElement.style.setProperty('--pdpdiscription-height', pdpdiscriptionHeight);
  }
}
setPdpdiscriptionHeight();

window.addEventListener('resize', setPdpdiscriptionHeight);

function setPpdmainimage() {
  const pDPmainimage = document.querySelector('.product-area__media .main_image_slider');
  if (pDPmainimage) {
    const pDPmainimageHeight = pDPmainimage.offsetHeight + 'px';
    document.documentElement.style.setProperty('--pDPmainimage-height', pDPmainimageHeight);
  }
}
setPpdmainimage();

window.addEventListener('resize', setPpdmainimage);

{
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      const button = document.querySelector('.product-detail__form__action');
      if (!button) {
        console.error('Button not found');
        return;
      }
      const originalOffset = button.offsetTop;
      function updateButtonStickiness() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        if (scrollPosition > viewportHeight) {
          document.body.classList.add('sticky_button_mobile');
        } else {
          document.body.classList.remove('sticky_button_mobile');
        }
      }

      updateButtonStickiness();

      window.addEventListener('scroll', updateButtonStickiness);

      window.addEventListener('resize', function () {
        const isSticky = document.body.classList.contains('sticky_button_mobile');
        if (isSticky) {
          document.body.classList.remove('sticky_button_mobile');
        }
        const updatedOffset = button.offsetTop;
        if (isSticky) {
          document.body.classList.add('sticky_button_mobile');
        }
        originalOffset = updatedOffset;
        updateButtonStickiness();
      });
    }
  });
}


{
  window.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.mobile-count')) {
      document.querySelector('.mobile-count').classList.remove('hidden');
    }
  });
}

{
    document.addEventListener("DOMContentLoaded", function () {
     if (!document.body.classList.contains('template-suffix-old-pdp')) { 
      const blocks = document.querySelectorAll(".template-product #page-content .shopify-section");
      const mediaElement = document.querySelector('.product-area__media');
      const header = document.querySelector('#site-control');
      const isDesktop = window.innerWidth >= 992;
      if (!isDesktop) return;

      let index = 0;
      let isScrolling = false;
      let isHovering = false;

      const swiperContainer = mediaElement && (mediaElement.querySelector('.swiper') || mediaElement.querySelector('.swiper-container'));

      if (mediaElement) {
        mediaElement.addEventListener('mouseenter', () => { isHovering = true; });
        mediaElement.addEventListener('mouseleave', () => { isHovering = false; });
      }

      function scrollTo(i) {
        if (!blocks[i]) return;
        isScrolling = true;
        const headerHeight = header ? header.offsetHeight : 0;
        const blockTop = blocks[i].getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          block: 'start',
          top: blockTop - headerHeight,
          behavior: "smooth"
        });
        setTimeout(() => { isScrolling = false; }, 1000);
      }

      function trySwiperHandle(swiperEl, deltaY, e) {
        if (!swiperEl) return false;

        const swiper = swiperEl.swiper || (swiperEl.closest && swiperEl.closest('.swiper') && swiperEl.closest('.swiper').swiper);
        if (!swiper) return false;

        if (swiper.animating) {
          e.preventDefault();
          return true;
        }
        if (deltaY > 0) {
          if (!swiper.isEnd && swiper.allowSlideNext !== false) {
            swiper.slideNext();
            e.preventDefault();
            return true;
          }
          return false;
        }
        if (deltaY < 0) {
          if (!swiper.isBeginning && swiper.allowSlidePrev !== false) {
            swiper.slidePrev();
            e.preventDefault();
            return true;
          }
          return false;
        }

        return false;
      }
      window.addEventListener("wheel", function (e) {
        if (document.body.classList.contains("popup-open")) return;
        if (isScrolling) return;

        const eventInsideMedia = mediaElement && (mediaElement === e.target || mediaElement.contains(e.target));
        const eventInsideSwiper = swiperContainer && (swiperContainer === e.target || swiperContainer.contains(e.target));

        if (swiperContainer && (eventInsideSwiper || eventInsideMedia || isHovering)) {
          const handled = trySwiperHandle(swiperContainer, e.deltaY, e);
          if (handled) return; 
        }

        if (e.deltaY > 0 && index < blocks.length - 1) {
          index++;
          scrollTo(index);
        } else if (e.deltaY < 0 && index > 0) {
          index--;
          scrollTo(index);
        }
      }, { passive: false });
    }
  });
}


document.addEventListener("DOMContentLoaded", function () {
  const popupHeaders = document.querySelectorAll('.popup_header_content');
  const closeButtons = document.querySelectorAll('.popup_close');
  const overlays = document.querySelectorAll('.popup_bg_overlay');

  // Toggle popup on header click
  popupHeaders.forEach(header => {
    header.addEventListener('click', function () {
      const container = this.closest('.popup_inner_container');
      const isActive = container.classList.contains('active');

      container.classList.toggle('active');

      if (!isActive) {
        document.body.classList.add('popup-open');
      } else {
        document.body.classList.remove('popup-open');
      }
    });
  });

  // Close popup on close button click
  closeButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const container = this.closest('.popup_inner_container');
      container.classList.remove('active');
      document.body.classList.remove('popup-open');
    });
  });

  // Close popup on overlay click
  overlays.forEach(overlay => {
    overlay.addEventListener('click', function () {
      const container = this.closest('.popup_inner_container');
      container.classList.remove('active');
      document.body.classList.remove('popup-open');
    });
  });
});

setTimeout(() => {
  document.querySelectorAll(".was-price.theme-money").forEach(item => {
    item.textContent = item.textContent.replace(/\s+€/g, '€');
  });
}, 1000);

// {
//   document.addEventListener("DOMContentLoaded", function () {
//     const swatch = document.querySelector('.product-swatch.swach_mobile_view');

//     if (swatch && swatch.children.length === 0) {
//       swatch.style.display = 'none';
//     }
//   });
// }
{
  document.addEventListener('DOMContentLoaded', function () {
    const pdpChatLink = document.querySelector('.js-pdp-chat-link');

    if (!pdpChatLink) return;

    pdpChatLink.addEventListener('click', function (e) {  
      if (window.openOct8neChat) {
        window.openOct8neChat();
      } else {
        const chatIconLink = document.querySelector('.chat-icon-link');
        if (chatIconLink) {
          chatIconLink.click();
        }
      }
    });
  });
}